// @ts-nocheck
import { jsx as _jsx } from "react/jsx-runtime";
import ErrorBoundary from '../ErrorBoundary';
const StartPage = ({ children })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "rcc-startpage",
        children: /*#__PURE__*/ _jsx(ErrorBoundary, {
            children: children
        })
    });
};
export default StartPage;
